<div class="side-modal-backdrop" (click)="cancel()"></div>
<div *ngIf="paypalForm" class="side-form-container" [fullScreen]="true" [libLoading]="loading">
  <form id="paypalForm" stickyScroll scrollContainerId="paypalContainer" [bottomOffset]="0" novalidate  [formGroup]="paypalForm">
    <div class="scrollable-fields-container">
	<h2>Smart Code</h2>
	<h4 class="form-subtitle">Smart Code accelerates the development of custom integration solutions by providing a suite of powerful code generators.</h4>

  <div class="table-container">
    <table class="products-table">
      <thead>
      <tr>
        <th>Product</th>
        <th>Pricing</th>
        <th>Description</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td class="product-name">REST Generator</td>
        <td class="price">Paid</td>
        <td>Helps developers create APIs quickly by automating boilerplate code, including integration flows, mappings, specifications, error handling, logging, and framework setup.</td>
      </tr>
      <tr>
        <td class="product-name">UTIL Generator</td>
        <td class="price">By Category</td>
        <td>A set of utilities to simplify and accelerate development tasks.
        <ul>
          <li>Provides a set of converters to simplify working with RAML, enabling interchangeability between schema formats.</li>
          <li>Automates the creation of Postman Collections from schemas (supports RAML, OAS, and WSDL).</li>
        </ul>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="fields-group border paypal-form-section" [class.disabled]="premiumLicense">

	<h3>Developer Plan</h3>
  <div>
    <p class="input-instruction">We offer a pay-as-you-go developer plan that provides a simple way to accelerate your development with no monthly commitments.</p>

      <table class="radio-table">
        <thead>
        <tr>
          <th>Item</th>
          <th>Amount</th>
          <th>Price</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="product-name">REST Generator</td>
          <td>
          <lib-form-field (dropdownChanged)="updateTotalPrice()" [inlineLayout]="true" [noBottomMargin]="true" [formGroupParameter]="paypalForm" [fieldSettings]="paypalFormSettings['uses']" ></lib-form-field>
          </td>
          <td id="restGeneratorPrice" [class.price]="totalCost !== '$0.00 USD'" [class.n-a]="totalCost === '$0.00 USD'">{{totalCost}}</td>
        </tr>
        <tr>
          <td class="product-name">UTIL Generator - Schema Converters</td>
          <td class="n-a">-</td>
          <td class="free">FREE</td>
        </tr>
        <tr>
          <td class="product-name">UTIL Generator - Postman Automation</td>
          <td class="n-a">-</td>
          <td class="free">FREE</td>
        </tr>
        <tr class="summary-row">
          <td class="product-name">Total Cost</td>
          <td></td>
          <td [class.price]="totalCost !== '$0.00 USD'" [class.n-a]="totalCost === '$0.00 USD'">{{totalCost}}</td>
        </tr>
        </tbody>
      </table>

      <div class="paypal-instruction">
        <p>Your purchase will be processed via PayPal. To apply the license, you must have an active account. If the license fails to apply, please contact Support through Diamond Edge IT’s <a [routerLink]="['',{outlets: {sidePopup: 'supportrequest'}}]">Support Request Form</a> or contact us immediately at <a href="mailto:support@smartcodeplatform.com">support@smartcodeplatform.com</a>. By completing your purchase, you agree to our Terms of Service.</p>
      </div>

  </div>
  </div>

  <!-- <button (click)="getUsageLicense(1,null)">GET ONE USAGE</button> -->

    </div>

    <div class="form-group bottom-absolute">
      <button (click)="cancel()" type="button" class="secondary">Cancel</button>
      <button (click)="submit()" [disabled]="!paypalForm.valid" class="primary" type="submit">Buy Now</button>
    </div>

  </form>
</div>

<ng-template #paypalModal>
  <header class="paypal-modal-heading">

    <h2>Submit payment of: <span>{{totalCost}}</span></h2>
    <button *ngIf="!noClose" class="close-popup-button close-button modal-close" (click)="modalRef.hide()">close</button>
  </header>
  <ngx-paypal class="" [config]="payPalConfig"></ngx-paypal>
</ng-template>


<ng-template #licenseErrorMessage>
  <div>
    <p>Your license will be updated in 48 hours.  If you license is not applied please contact support on <a href="mailto:support@smartcodeplatform">support&#64;smartcodeplatform.com</a>. <lib-clipboard-copy [text]="''" [value]="'support@smartcodeplatform'" [message]="'The EMAIL ADDRESS was copied to clipboard.'"></lib-clipboard-copy> </p>
  </div>
</ng-template>
